import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SupportTicketsModel } from './tickets.model';
import { SupportTicketsResponsesModel } from './ticketsResponses.model';
import { ApiResponse } from '../../models/base';

@Injectable({
  providedIn: 'root',
})
export class SupportTicketsService {
  private readonly http = inject(HttpClient);

  async addTicket(ticket: SupportTicketsModel): Promise<SupportTicketsModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<SupportTicketsModel>>(
        environment.apiUrl + '/support/tickets',
        ticket
      )
    );

    return response.data;
  }

  async getListTickets(): Promise<SupportTicketsModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<SupportTicketsModel[]>>(environment.apiUrl + '/support/tickets')
    );

    return response.data;
  }

  async getTicket(ticketId: number): Promise<SupportTicketsModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<SupportTicketsModel>>(
        environment.apiUrl + '/support/tickets/' + ticketId
      )
    );

    return response.data;
  }

  async addTicketResponse(
    ticketResponse: SupportTicketsResponsesModel
  ): Promise<SupportTicketsResponsesModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<SupportTicketsResponsesModel>>(
        environment.apiUrl + '/support/ticketsresponses',
        ticketResponse
      )
    );

    return response.data;
  }

  async getListTicketResponses(ticketId: number): Promise<SupportTicketsResponsesModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<SupportTicketsResponsesModel[]>>(
        environment.apiUrl + '/support/ticketsresponses/' + ticketId
      )
    );

    return response.data;
  }

  async resolveTicket(ticketId: number): Promise<SupportTicketsResponsesModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<SupportTicketsResponsesModel>>(
        environment.apiUrl + '/support/tickets/solve/' + ticketId
      )
    );

    return response.data;
  }
}